<div class="container-box product-configurator" *ngIf="cancelProductDetail !== null">
  <h1>Remove all licenses</h1>
  <div class="error-container" aria-live="assertive">
    <div class="alert valign-children-middle" *ngIf="errorMessage">
      <div class="alert-error" aria-label="Alert.">
        <i class="icon-badgealert" aria-hidden="true"></i>
      </div>
      <div>
        <h2>Something isn't working</h2>
        <p [innerHTML]='errorMessage'></p>
      </div>
    </div>
  </div>
  <section>
    <div><strong>Selected product:</strong></div>
    <div>{{cancelProductDetail.specName}}</div>
    <div>Foundation account: {{cancelProductDetail.brokerAccountClientId}}</div>
    <div><strong>Wireless number:</strong> {{billingClientId}}</div>
    <div>{{cancelProductDetail.productDesc}}</div>
  </section>
  <div class="alert valign-children-middle mar-top-20">
    <div class="alert-info" aria-label="Information">
      <i class="icon-flat-info"></i>
    </div>
    <div>
      <p>By removing all licenses from users, you are canceling this product. Users will no longer be able to access this product.</p>
    </div>
  </div>
  <div class='lisence-container'>
    <div class="row">
      <div class="qty-block already-own">
        <div class='col-md-9'>
          <span class="col-md-12">You currently have</span>
          <div class="col-md-12 margin-top"> {{quantity}} <span class="license" [innerHTML]="(quantity > 1)? 'licenses':'license'"></span> &#64; {{ unitPrice |currency:'USD':true:'1.0-0'}}
            per month</div>
        </div>
        <div class='col-sm-10 col-md-3'>
          <div class="price-detail">
            <div class="price-value">{{ totalPrice |currency:'USD':true:'1.2-3'}}</div>
            <div class="per-month">Per month </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class='lisence-container'>
    <div class="row">
      <div class="qty-block already-own">
        <div class='col-md-9'>
          <span class="col-md-12">Remove all licenses</span>
        </div>
        <div class='col-sm-10 col-md-3'>
          <div class="price-detail">
            <div class="price-value">-{{ totalPrice |currency:'USD':true:'1.2-3'}}</div>
            <div class="per-month">Per month </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class='singeline totalcontainer'>
    <div class='row'>
      <div class='col-md-7 col-sm-12'>
        <h3 class="heading-bold">Total charges*</h3>
      </div>
      <div class='col-sm-10 col-md-5 radio-margin'>
        <div class="price-detail">
          <p class="price-value">$0.00</p>
          <p class="per-month">Per month</p>
        </div>
      </div>
    </div>
  </div>
  <small>* All prices exclude applicable taxes, fees and surcharges.</small>
  <hr class="cart-hr hide-sm" />
  <div class='text-right checkout-btn'>
    <button type="button" class="btn btn-success btn-cart pull-right" aria-label="Continue" [disabled]='impoErr' (click)="goToReviewOrderPage()">Continue</button>
    <a class="btn btn-link btn-cart" href="javascript:void(0)" (click)="cancel()">Cancel</a>
  </div>
</div>
<app-mobile-pivot [pivots]="pivots"></app-mobile-pivot>